import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useAppSelector } from "../store/index.ts";
import ShowContainer from "./mui/ShowContainer.jsx";

export default function CusCaptcha({ captchaRef, onChange }) {
  const lang = useAppSelector((state) => state.common.lang);
  const publicKey = useAppSelector((state) => state.site.captchaUsing.publicKey);
  return (
    <ShowContainer condition={publicKey}>
      <ReCAPTCHA ref={captchaRef} hl={lang} sitekey={publicKey} onChange={onChange} />
    </ShowContainer>
  );
}
